import React from 'react'
import { ListGroup, ListGroupItem } from 'react-bootstrap'
import './EqxListGroup.css'

interface EqxListGroupProps {
    isChild?: boolean
    children?: React.ReactNode
    id?: string
    className?: string
}
const EqxListGroup = (props: EqxListGroupProps) => {
    return (
        <ListGroup className={(props.isChild ? 'eqx-list-group-child' : '') + ' eqx-list-group'}>
            {props.children}
        </ListGroup>
    )
}
const EqxListGroupItem = (props: { children?: React.ReactNode; selectable?: boolean, className?: string; key?: string | number; onClick?: React.MouseEventHandler; style?: React.CSSProperties }) => {
    const style: React.CSSProperties = props.style || {};
    if (props.selectable) {
        style.cursor = 'pointer';
        style.userSelect = 'none';
    }
    return <ListGroupItem className={props.className} onClick={props.onClick} style={style}>{props.children}</ListGroupItem>
}

export { EqxListGroup as default, EqxListGroupItem }

